// @ts-ignore
/* eslint-disable */
import request from "../../utils/request";

/** 获取新闻快讯 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /news/express */
export async function newsExpressUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.newsExpressUsingGETParams,
  options?: { [key: string]: any }
) {
  return request<API.PageResultListSsExpressResp>("/news/express", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 修改快讯点赞状态 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 PUT /news/express/like */
export async function newsExpressLikeUsingPUT(
  body: API.UpdateExpressLikeReq,
  options?: { [key: string]: any }
) {
  return request<API.BaseResultVoid>("/news/express/like", {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取新闻频道列表 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /news/getNewsChannels */
export async function newsGetNewsChannelsUsingGET(options?: {
  [key: string]: any;
}) {
  return request<API.BaseResultListNewsChannelResp>("/news/getNewsChannels", {
    method: "GET",
    ...(options || {}),
  });
}

/** 获取指定新闻详情 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /news/getNewsInfo */
export async function newsGetNewsInfoUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.newsGetNewsInfoUsingGETParams,
  options?: { [key: string]: any }
) {
  return request<API.BaseResultNewsContentResp>("/news/getNewsInfo", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取指定频道最新新闻列表 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /news/getNewsList */
export async function newsGetNewsListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.newsGetNewsListUsingGETParams,
  options?: { [key: string]: any }
) {
  return request<API.PageResultListNewsListResp>("/news/getNewsList", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 修改新闻点赞状态 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 PUT /news/like */
export async function newsLikeUsingPUT(
  body: API.UpdateNewsLikeReq,
  options?: { [key: string]: any }
) {
  return request<API.BaseResultVoid>("/news/like", {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}
